"use client";

import { useTranslations } from "use-intl";

import { PhoneCountrySelect } from "@/components/phone-country-select";
import { Input } from "@/components/ui/input";
import type { CountryCode } from "@garimpa/lib/countries";

interface PhoneNumberInputProps {
  id: string;
  country: CountryCode;
  number: string;
  autoFocus?: boolean;
  disabled?: boolean;
  onCountryChange: (country: CountryCode) => void;
  onNumberChange: (number: string) => void;
}

export function PhoneNumberInput({
  id,
  country,
  number,
  autoFocus,
  disabled,
  onCountryChange,
  onNumberChange,
}: PhoneNumberInputProps) {
  const t = useTranslations("globals.auth");

  return (
    <div className="flex w-full">
      <PhoneCountrySelect
        value={country}
        disabled={disabled}
        className="w-16 rounded-r-none border-r-0 bg-secondary hover:bg-secondary/80"
        onChange={onCountryChange}
      />
      <Input
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        autoFocus={autoFocus}
        placeholder={t("phoneNumberPlaceholder")}
        value={number}
        disabled={disabled}
        className="rounded-l-none bg-secondary px-4 py-2"
        onChange={(event) => onNumberChange(event.currentTarget.value)}
      />
    </div>
  );
}
